import styled from 'styled-components6';
import { ReactNode } from 'react';

const MapButtonContainer = styled.div`
    display: flex;
    margin: var(--rwl-spacing-sm);
    user-select: none;
    box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
    border-radius: 2px;
    cursor: pointer;
    background-color: rgb(255, 255, 255);
    color: black;
    padding: var(--rwl-spacing-sm);
    text-align: center;
    border: 0;
    line-height: 1.5;
`;

export const MapButton = ({
    children,
    ...rest
}: {
    children?: ReactNode | string;
    onClick?: (e: React.MouseEvent) => void;
    style?: React.CSSProperties;
    className?: string;
}): JSX.Element => {
    return <MapButtonContainer {...rest}>{children}</MapButtonContainer>;
};
